module.exports = __webpack_public_path__ + "img/content2.311c029b.png";